import { Column } from '../../components/Table/Table';

export const Columns = (t): Column[] => [
    { id: 'answerText', label: t('Master-data.hierarchy.detail.production.zone.audit.question.table-col-1') },
    { id: 'answerScore', label: t('Master-data.hierarchy.detail.production.zone.audit.question.table-col-2') },
];
